import React from 'react'

import { B1, H5, Stack } from '@zet/design-system'

interface IProps {
  title: string
  subTitle: string
}

export const HeaderDetailsSection: React.FC<IProps> = ({ title, subTitle }) => {
  return (
    <Stack className="my-4">
      <H5>{title}</H5>
      <B1 className="text-grays-70 w-[90%]">{subTitle}</B1>
    </Stack>
  )
}
